import { paymentStructure } from '../configs/createInvoiceConfigsV2';
import { countriesList, stateList } from 'constants/stateList';

export const getFormattedCountryList = () => {
  let countries = [];

  if (countriesList?.length > 0) {
    countries = countriesList?.map((country) => {
      return {
        label: country?.name,
        value: country?.name,
      };
    });
  }

  return countries;
};

export const getFormattedStateList = () => {
  let states = [];

  if (stateList?.length > 0) {
    states = stateList?.map((state) => {
      return {
        label: state?.abbreviation + ' - ' + state?.name,
        value: state?.abbreviation + ' - ' + state?.name,
      };
    });
  }

  return states;
};

export const convertPaymentStructuresToLowerCase = () => {
  let paymentStructures = { ...paymentStructure };
  for (let key in paymentStructures) {
    paymentStructures[key] = paymentStructures[key].toLowerCase();
  }
  return paymentStructures;
};

export const getInvoicePaidAmount = (selectedInvoice) => parseFloat(selectedInvoice?.paid_amount || 0);

export const DEPOSIT_ACCOUNT_MAPPING_TOOLTIP =
  'The selected deposit information will determine the account mapping if no account is already mapped.';

export const DEPOSIT_ACCOUNT_LOCK_TOOLTIP = 'Account type cannot be changed after payment is recorded';

export const invoiceHasPaymentsFromDetails = (invoiceDetails) => parseFloat(invoiceDetails?.paid_amount || 0) > 0;

export const getDepositInfoTooltipMessage = (isEditMode, isDepositLocked) =>
  isEditMode && isDepositLocked ? DEPOSIT_ACCOUNT_LOCK_TOOLTIP : DEPOSIT_ACCOUNT_MAPPING_TOOLTIP;

export const isDepositInfoDropdownDisabled = (isEditMode, isDepositLocked) => Boolean(isEditMode && isDepositLocked);

export const isZeroDollarInvoiceWithNoPayments = ({ totalAmount, paidAmount }) =>
  parseFloat(totalAmount || 0) === 0 && parseFloat(paidAmount || 0) === 0;

export const isInvoiceSubmitDisabled = (selectedBillingContact) => selectedBillingContact === undefined || selectedBillingContact === null;

export const shouldSkipZeroDollarPaymentPlanValidation = ({ paymentPlan, totalAmount, selectedInvoice }) =>
  paymentPlan && parseFloat(totalAmount || 0) === 0 && getInvoicePaidAmount(selectedInvoice) === 0;

export const shouldAutoDisableZeroDollarPaymentPlan = ({ paymentPlan, totalAmount, paidAmount }) =>
  Boolean(paymentPlan) && isZeroDollarInvoiceWithNoPayments({ totalAmount, paidAmount });

export const isForwardInvoiceEligible = (invoice) =>
  String(invoice?.invoice_status || '').toUpperCase() !== 'PAID' && parseFloat(invoice?.due_amount || 0) !== 0;
